import { getAsignaturas } from "../helpers/asignaturas";

const initialState = {
    asignaturas: []
}
const ASIGNATURA_LOADED = '[ASIGNATURA LD] ASIGNATURA LOADED'
const ASIGNATURA_ADD = '[ASIGNATURA ADD] ASIGNATURA ADD'
const ASIGNATURA_UPDATE_NAME = '[ASIGNATURA UP] ASIGNATURA UPDATE NAME'
const ASIGNATURA_UPDATE_PHOTO = '[ASIGNATURA UP] ASIGNATURA UPDATE PHOTO'
const TEMA_UP_NUM_THEMES = '[TEMAS UP] TEMA UPDATE NUMBER THEMES'
const ASIGNATURA_LOGOUT = '[ASIG LOGOUT] ASIGNATURA LOGOUT'
export const startLoadingAsignatura = (email) => {
    return async (dispatch) => {
        const asignaturas = await getAsignaturas(email);
        dispatch(setAsignaturas(asignaturas))
    }
}

const setAsignaturas = (asignaturas) => ({
    type: ASIGNATURA_LOADED,
    payload: asignaturas
})

export const updateNameAsig = (id, nameSubject) => ({
    type: ASIGNATURA_UPDATE_NAME,
    payload: {
        id, 
        nameSubject
    }
})

export const updateImagenAsig = (id, photoURL) => ({
    type: ASIGNATURA_UPDATE_PHOTO,
    payload: {
        id, 
        photoURL
    }
})

export const startNewAsignatura = (id, nameAsig,url) => {
    return async (dispatch) => {
        const newAsi = {
            comments: 0,
            likes: 0,
            nameSubject: nameAsig,
            photoURL: url,
            students: 0,
            themes: 0
        }
        dispatch(addNewAsig(id, newAsi));
    }
}

const addNewAsig = (id, newAsi) => ({
    type: ASIGNATURA_ADD,
    payload: {
        id, ...newAsi
    }
})


export const refreshthemes = (id,themes) => ({
    type: TEMA_UP_NUM_THEMES,
    payload: {
        id,
        themes
    }
})

export const logoutAsig = () => ({type: ASIGNATURA_LOGOUT})

const AsignaturaReducer = (state = initialState, action ) => {
    switch (action.type) {
        case ASIGNATURA_LOADED:
            return {
                ...state,
                asignaturas: [...action.payload],
            }
        case ASIGNATURA_UPDATE_NAME:
            return {
                ...state,
                asignaturas: state.asignaturas.map(
                    e => (e.id === action.payload.id) 
                    ? {...e, nameSubject: action.payload.nameSubject}
                    : e
                )
            }
        case ASIGNATURA_UPDATE_PHOTO:
            return {
                ...state,
                asignaturas: state.asignaturas.map(
                    e => (e.id === action.payload.id) 
                    ? {...e, photoURL: action.payload.photoURL}
                    : e
                )
            }
        case TEMA_UP_NUM_THEMES:
            return {
                ...state,
                asignaturas: state.asignaturas.map(
                    e => (e.id === action.payload.id)
                    ? {...e, themes: action.payload.themes}
                    : e
                )
            }
        case ASIGNATURA_ADD:
            return {
                ...state,
                asignaturas: [...state.asignaturas, action.payload]
            }
        case ASIGNATURA_LOGOUT:
            return {}
        default:
            return state
    }
}

export default AsignaturaReducer